import { useEffect } from "react";
import Banner from "../components/Banner";

export default function PageRegister() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://paperform.co/__embed.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Banner className="bg-white-after">
        <div className="col-12 mb-3">
          <div className="display-1 color-white">Join us at FinComp '27</div>
        </div>

        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-0">
            Through December 31, 2026, you can get your discounted early-bird
            rate of $1,650 ($2,150 standard rate).
            <br />
            <br />
            Teams should grow together! Additional team members can register at
            a discounted group rate of $1,450 each (a $700 savings).
          </p>

          {/* <p className="color-white mb-0">
            Standard admission pricing is $2,150.
            <br />
            Teams learn better together! Additional team members can register at
            a discounted group rate of $1,295 each (a $700 savings).
          </p> */}
        </div>
      </Banner>

      <section>
        <div className="row">
          <div className="col-12">
            <div data-paperform-id="fincomp2027"></div>
          </div>
        </div>
      </section>
    </>
  );
}
